<template lang="pug">
aside-modal(id="regionModal", width="w-xxxl", :loading="loading")
    span(slot="header-text") {{ regionExists ? 'Update' : 'Create' }} Region
    div.p-a(slot="body")
        form(id="regionForm")
            fieldset(:disabled="loading")
                div.md-form-group
                    input.md-input(
                        placeholder="e.g West",
                        type="text",
                        v-model="region.name",
                        :readonly="!canManageRegion"
                        required
                    )
                    label Name

                div.md-form-group
                    label {{ trans('general.outlets') }}
                    multiselect(
                        v-model="region.outlets",
                        label="name",
                        track-by="id",
                        placeholder="Type to search",
                        :options="outletList",
                        :multiple="true",
                        :close-on-select="false",
                        :hide-selected="false",
                        :max-height="400",
                        :limit="30",
                        :loading="outlets_loading"
                        @search-change="loadOutlets"
                        :disabled="!canManageRegion"
                    )

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-region')"
        v-if="canManageRegion"
    ) 
        v-loading(loader="save-region") Save
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    data() {
        return {
            region: null,
            outletList: [],
            outlets_loading: false,
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        loading() {
            return (
                this.onLoading('fetch-region') || this.onLoading('save-region')
            );
        },

        regionExists() {
            return this.region.id !== null;
        },

        canManageRegion() {
            return Auth.hasPermissionTo('franchise_manage_regions');
        },
    },

    created() {
        this.region = this.newRegion();
    },

    mounted() {
        this.loadOutlets();
        this.registerEvent();
    },

    methods: {
        ...mapActions('region', ['getRegion', 'updateRegion', 'createRegion']),

        newRegion() {
            return {
                id: null,
                name: null,
                outlets: [],
            };
        },

        toggleModal(action) {
            $('#regionModal').modal(action);
        },

        getOultetList() {
            let api = Laroute.route('franchise.vue.outlets');
            this.$http.get(api).then(response => {
                this.outlets = response.data.data;
            });
        },

        loadOutlets: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.outlets');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.outlets_loading = true;
            this.$http.get(api, options).then(response => {
                this.outletList = response.data.data;
                this.outlets_loading = false;
            });
        }, 500),

        registerEvent() {
            this.$on('show-region', id => {
                if (this.loading) return;

                if (id === null) {
                    this.region = this.newRegion();
                    this.toggleModal('show');
                } else {
                    this.getRegion(id)
                        .then(res => {
                            this.toggleModal('show');
                            this.region = _.pick(res.data, [
                                'id',
                                'name',
                                'outlets',
                            ]);
                        })
                        .catch(err => {
                            this.showApiError(err);
                        });
                }
            });
        },

        submit() {
            /** Promise */
            let save;

            if (!this.validateForm('regionForm')) return;

            const outlets = this.region.outlets.map(p => p.id);

            const region = Object.assign(_.pick(this.region, ['id', 'name']), {
                outlets,
            });

            if (!this.regionExists) {
                save = this.createRegion(region);
            } else {
                save = this.updateRegion(region);
            }

            save.then(res => {
                this.showToastrSuccess();

                if (this.regionExists) {
                    this.toggleModal('hide');
                } else {
                    this.region = this.newRegion();
                }

                this.$emit('region-saved');
            }).catch(err => {
                this.showApiError(err);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/region/region-form.vue